import { Tile } from '@creditflowresearch/uilib/Tile';
import TileHeader from './TileHeader';
import BondsTables from './BondsTables';
import { useModuleVisibility } from '@/creditflowresearch/application/ModuleVisibility';
import { BONDS_TILE_HEADER_MAPPING_NAME } from '@/creditflowresearch/application/Bonds/constants';
import { ComposeBondsTileContext } from '@/creditflowresearch/application/Bonds/ComposeBondsTileContext';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const BondsTile = () => {
  const isModuleVisible = useModuleVisibility(BONDS_TILE_HEADER_MAPPING_NAME);

  if (!isModuleVisible) {
    return null;
  }

  return (
    <Tile dataTest="bondsTile" className={ spacesStyles.mtl }>
      <TileHeader />
      <BondsTables />
    </Tile>
  );
};

export default () => {
  const { bondTileData } = useParentPageContext();

  return (
    <ComposeBondsTileContext bondTileData={ bondTileData }>
      <BondsTile />
    </ComposeBondsTileContext>
  );
};
